
export default {
  // Header
  'header.home': 'Home',
  'header.superone': 'SuperOne',
  'header.contact': 'Contact',
  'header.imprint': 'Imprint',
  'header.privacy': 'Privacy',
  
  // Footer
  'footer.quickLinks': 'Quick Links',
  'footer.legal': 'Legal',
  'footer.contact': 'Contact',
  'footer.rights': 'All rights reserved.',
  'footer.company': 'Future Now Ltd.',
  'footer.address': 'Victoriastreet 2a, SWE-1, London, United Kingdom',
  'footer.email': 'info@olaf-niggemann.com',
  
  // Cookie Banner
  'cookie.title': 'Cookie Settings',
  'cookie.description': 'We use cookies to improve your experience on our website. By using our website, you agree to the use of cookies.',
  'cookie.accept': 'Accept All',
  'cookie.reject': 'Reject',
  'cookie.customize': 'Customize',
  'cookie.necessary': 'Necessary',
  'cookie.analytics': 'Analytics',
  'cookie.marketing': 'Marketing',
  'cookie.necessaryDesc': 'These cookies are required for the basic functions of the website.',
  'cookie.analyticsDesc': 'These cookies help us understand how visitors interact with our website.',
  'cookie.marketingDesc': 'These cookies are used to make advertising more relevant to you.',
  'cookie.save': 'Save Settings',
  
  // Maintenance
  'maintenance.title': 'Maintenance Mode',
  'maintenance.subtitle': 'This page is in maintenance mode. We will be back shortly.',
  'maintenance.description': 'We are currently working on improvements for you. Thank you for your patience.',
  'maintenance.contact': 'For urgent inquiries, please contact us at:',
  
  // Common
  'common.learnMore': 'Learn More',
  'common.getStarted': 'Get Started',
  'common.readMore': 'Read More',
  'common.backToHome': 'Back to Home',
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.success': 'Success',
};
